module.exports = __webpack_public_path__ + "static/img/14000058.fa01472f.png";